// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/subscription.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelCustomerSubscriptionRequest, CreateCustomerSubscriptionRequest, CustomerSubscription, GetCustomerSubscriptionRequest, ListCustomerSubscriptionsRequest, ListCustomerSubscriptionsResponse, PauseCustomerSubscriptionRequest, ResumeCustomerSubscriptionRequest, UpdateCustomerSubscriptionLinesRequest } from "./subscription_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.CustomerSubscriptionService
 */
export const CustomerSubscriptionService = {
  typeName: "omnios.v1.CustomerSubscriptionService",
  methods: {
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.CreateSubscription
     */
    createSubscription: {
      name: "CreateSubscription",
      I: CreateCustomerSubscriptionRequest,
      O: CustomerSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.GetSubscription
     */
    getSubscription: {
      name: "GetSubscription",
      I: GetCustomerSubscriptionRequest,
      O: CustomerSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.ListSubscriptions
     */
    listSubscriptions: {
      name: "ListSubscriptions",
      I: ListCustomerSubscriptionsRequest,
      O: ListCustomerSubscriptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.PauseSubscription
     */
    pauseSubscription: {
      name: "PauseSubscription",
      I: PauseCustomerSubscriptionRequest,
      O: CustomerSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.ResumeSubscription
     */
    resumeSubscription: {
      name: "ResumeSubscription",
      I: ResumeCustomerSubscriptionRequest,
      O: CustomerSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.CancelSubscription
     */
    cancelSubscription: {
      name: "CancelSubscription",
      I: CancelCustomerSubscriptionRequest,
      O: CustomerSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CustomerSubscriptionService.UpdateSubscriptionLines
     */
    updateSubscriptionLines: {
      name: "UpdateSubscriptionLines",
      I: UpdateCustomerSubscriptionLinesRequest,
      O: CustomerSubscription,
      kind: MethodKind.Unary,
    },
  }
};

